export function formUTCDate (date, fmt) {
  if (date === undefined) {
    return
  }
  date == undefined ? new Date() : date;
  date = typeof date === 'number' ? new Date(date) : date;
  date = typeof date === 'string' ? new Date(Number(date)) : date;

  fmt = fmt || 'yyyy-MM-dd HH:mm:ss';
  var obj =
  {
    'y': date.getUTCFullYear(), // 年份，注意必须用getFullYear
    'M': date.getUTCMonth() + 1, // 月份，注意是从0-11
    'd': date.getUTCDate(), // 日期
    'q': Math.floor((date.getUTCMonth() + 3) / 3), // 季度
    'w': date.getUTCDay(), // 星期，注意是0-6
    'H': date.getUTCHours(), // 24小时制
    'h': date.getUTCHours() % 12 == 0 ? 12 : date.getUTCHours() % 12, // 12小时制
    'm': date.getUTCMinutes(), // 分钟
    's': date.getUTCSeconds(), // 秒
    'S': date.getUTCMilliseconds() // 毫秒
  };

  var week = ['天', '一', '二', '三', '四', '五', '六'];

  for (var i in obj) {
    fmt = fmt.replace(new RegExp(i + '+', 'g'), function (m) {
      var val = obj[i] + '';

      if (i == 'w') {
        return (m.length > 2 ? '星期' : '周') + week[val];
      }

      for (var j = 0, len = val.length; j < m.length - len; j++) {
        val = '0' + val;
      }
      return m.length == 1 ? val : val.substring(val.length - m.length);
    });
  }
  return fmt;
}



// WEBPACK FOOTER //
// ./src/date.js